import { dialog, InputJson, toDisplayCase } from "nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navbar";
import FormFactory from "../../../../components/FormFactory";
import DialogModal from "../../../../components/Dialog";
import DialogTable from "../../../../components/DialogTable";
import BreakdownTable from "../../../../components/BreakdownTable";
import ReceivableDetails from "./components/ReceivableDetails";
import LoadingState from "../../../../components/LoadingState";
import "./receive.css";
import ProgressState from "../../../../components/ProgressState";
import Loader from "../../../../components/Loader";
import ReceivableItemFormViewPresenter from "./ReceivableItemFormViewPresenter";
import PizzaLoader from "../../../../components/PizzaLoader";

class ReceivableItemFormViewPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      selectedRawIds: [],
      loading: false,
    };
    this.presenter = new ReceivableItemFormViewPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    // try route state first
    const fromNav = this.props.location?.state?.payload;
    // fallback to sessionStorage if page was refreshed
    const fromStorage = sessionStorage.getItem("receivable_items_import");
    const payload = fromNav || (fromStorage ? JSON.parse(fromStorage) : null);

    if (payload) {
      this.setState({ object: payload });
      // If you use a presenter that manages object state:
      // this.presenter?.onChangeObject?.(payload);
    }
  }

  getCollectionName() {
    return "receivable_item";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  handleOpenRaw() {
    const schema = this.getSchema("raw_materials");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.raw_materials || [];

              console.log("exxx", existing);

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const existingItem = mergedMap.get(item.id);
                mergedMap.set(item.id, {
                  ...item,
                  quantity: existingItem?.quantity || item.quantity || "",
                });
              }

              return {
                object: {
                  ...prev.object,
                  raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleDeleteSelected() {
    const { selectedRawIds, object } = this.state;
    const updated = (object.raw_materials || []).filter(
      (item) => !selectedRawIds.includes(item.id)
    );

    this.setState({
      object: {
        ...object,
        raw_materials: updated,
      },
      selectedRawIds: [], // reset after delete
    });
  }

  onChange(value, field) {
    if (field === "remarks") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasQuantity: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = (this.state.object.raw_materials || []).map(
      (item) => item.id
    );
    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);
    this.setState({ selectedRawIds: updated });
  };

  handleChangeQuantity = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      quantity: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeReference = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      reference: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeWarehouse = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      warehouse: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeDiscount = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      discount: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  onSaveDraft() {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit("Draft")}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onPartiallyReceive() {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit("Partially Receive")}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onConfirmFullReceipt() {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit("Received")}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickBack() {
    this.presenter.onClickBack();
    sessionStorage.removeItem("receivable_items_import");
  }

  render() {
    const object = this.state.object;
    const params = this.getParams();
    console.log("params", params);
    console.log("object", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />

        <div className="overflow-auto">
          {this.state.loading && (
            <div className="loading-overlay">
              {/* <ProgressState /> */}
              {/* <Loader /> */}
              <PizzaLoader />
            </div>
          )}
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => {
                    this.navigateBack();
                    sessionStorage.removeItem("receivable_items_import");
                  }}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {params.view === "view"
                  ? "View " +
                    (schema.label || toDisplayCase(this.getCollectionName()))
                  : label +
                    (schema.label || toDisplayCase(this.getCollectionName()))}
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form
                // onSubmit={this.onSubmitForm.bind(this)}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {object?.id && params.view === "view" ? (
                          <ReceivableDetails object={object} />
                        ) : (
                          <FormFactory
                            schema={schema}
                            object={object}
                            onChange={this.onChange.bind(this)}
                            excludeFields={[
                              "raw_materials",
                              "cost",
                              "createdBy",
                              "updatedBy",
                              "status",
                            ]}
                          />
                        )}
                      </>
                    )}
                  </div>

                  <BreakdownTable
                    title="Item List"
                    data={object.raw_materials || []}
                    selectedIds={this.state.selectedRawIds}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onChange={this.handleChangeQuantity}
                    onAdd={() => this.handleOpenRaw()}
                    onDelete={() => this.handleDeleteSelected()}
                    // onPriceChange={}
                    onReferenceChange={this.handleChangeReference}
                    onWarehouseChange={this.handleChangeWarehouse}
                    // onNetPriceChange={}
                    onDiscountChange={this.handleChangeDiscount}
                    disableAdd={!this.state.hasQuantity && !this.getObjectId()}
                    hasQuantity={this.state.hasQuantity || !!this.getObjectId()}
                    showUOM={false}
                    showPrice={true}
                    showReference={true}
                    showWarehouse={true}
                    showDetailsRow={false}
                    disableQty={params.view === "view" ? true : false}
                    showAddButton={
                      ["Partially Receive", "Received"].includes(object?.status)
                        ? false
                        : true
                    }
                  />

                  <div className="mt-4 text-center">
                    {object?.id && params.view === "view" ? (
                      <button
                        type="button"
                        className="btn fs-sm text-white w-25"
                        onClick={this.onClickBack.bind(this)}
                        style={{ backgroundColor: "#82c14a" }}
                      >
                        Back
                      </button>
                    ) : (
                      <div className="row g-3 mt-3">
                        <div className="col-12 col-md-6">
                          <button
                            type="button"
                            className="btn w-100 py-2 fw-semibold"
                            onClick={this.onClickBack.bind(this)}
                            style={{
                              backgroundColor: "#d1d1d1",
                              color: "#000",
                              borderRadius: 8,
                            }}
                          >
                            Cancel
                          </button>
                        </div>

                        <div className="col-12 col-md-6">
                          {object.status !== "Draft" && (
                            <button
                              type="button"
                              className="btn w-100 py-2 text-white fw-semibold"
                              onClick={this.onSaveDraft?.bind(this)}
                              style={{
                                backgroundColor: "#2E88A7",
                                borderRadius: 8,
                              }}
                            >
                              Draft
                            </button>
                          )}
                        </div>

                        <div className="col-12 col-md-6">
                          <button
                            type="button"
                            className="btn w-100 py-2 text-white fw-semibold"
                            onClick={this.onConfirmFullReceipt?.bind(this)}
                            style={{
                              backgroundColor: "#82c14a",
                              borderRadius: 8,
                            }}
                          >
                            Confirm Full Receipt
                          </button>
                        </div>

                        <div className="col-12 col-md-6">
                          <button
                            type="button"
                            className="btn w-100 py-2 fw-semibold"
                            onClick={this.onPartiallyReceive?.bind(this)}
                            style={{
                              backgroundColor: "#FFCC33",
                              color: "#000",
                              borderRadius: 8,
                            }}
                          >
                            Partially Receive
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ReceivableItemFormViewPage);
